/**
 * Environment constants and helpers
 */

enum Environment {
  STG = 'stg',
  PRD = 'prd',
}

export type EnvironmentType = (typeof Environment)[keyof typeof Environment];

/**
 * Get the current environment from VITE_ENV
 */
export const getEnvironment = (): string => {
  return import.meta.env.VITE_ENV || Environment.STG;
};

/**
 * Check if running in production
 */
export const isProduction = (): boolean => {
  return getEnvironment() === Environment.PRD;
};

/**
 * Check if running in staging
 */
export const isStaging = (): boolean => {
  return getEnvironment() === Environment.STG;
};
